import Vue from 'vue'
import posthog from 'posthog-js'
import config from '../configs'
import {
  beforeSend,
  installVueErrorHandler
} from './posthog-error-management'

export { capturePostHogException } from './posthog-error-management'

const { posthogKey, posthogHost } = config.analytics

const EMAIL_REGEX = /(\S+)@(\S+\.\S+)/g
const PHONE_REGEX = /(?:\+?\d{1,3}[\s.-]?)?(?:\(?\d{2,4}\)?[\s.-]?)?\d{3,4}[\s.-]?\d{3,4}(?:[\s.-]?\d{1,4})?/g

function looksLikePhone(value) {
  const digits = value.replace(/\D/g, '')
  return digits.length >= 7 && digits.length <= 15
}

function maskSensitiveText(text) {
  if (!text || !text.trim()) {
    return text
  }

  return text
    .replace(EMAIL_REGEX, (_, local, domain) => {
      return '*'.repeat(local.length) + '@' + '*'.repeat(domain.length)
    })
    .replace(PHONE_REGEX, (match) => {
      if (!looksLikePhone(match)) {
        return match
      }
      return '*'.repeat(match.length)
    })
}

function isImpersonatedSession() {
  const value = $cookies.get('is_impersonated_session')
  return value === true || value === 'true'
}

export function identifyPostHogUser(user) {
  if (!posthogKey || !user || user.id == null) {
    return
  }

  posthog.identify(String(user.id), {
    email: user.email || undefined,
    name: user.name || undefined,
    company_id: user.company_id || undefined,
    is_impersonated: isImpersonatedSession()
  })

  if (user.company_id != null) {
    posthog.group('company', String(user.company_id))
  }
}

export function resetPostHog() {
  if (!posthogKey) {
    return
  }

  posthog.reset()
}

export function capturePostHogEvent(eventName, properties = {}) {
  if (!posthogKey || !eventName) {
    return
  }

  posthog.capture(eventName, properties)
}

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageview: 'history_change',
    person_profiles: 'identified_only',
    capture_exceptions: true,
    before_send: beforeSend,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
      maskTextFn: maskSensitiveText,
      blockSelector: 'img, video, canvas'
    }
  })

  const appRelease = process.env.VUE_APP_POSTHOG_RELEASE
  if (appRelease) {
    posthog.register({ app_release: appRelease })
  }

  installVueErrorHandler(Vue)

  Vue.prototype.$posthog = posthog
}
